import api from "./apiConfig";

export const REGISTER_AIRBNB = async (propertieId, airbnbDocuments) => {
    try {
        const formData = new FormData();
        formData.append("propertieId", propertieId);

        airbnbDocuments.forEach((doc) => {
            formData.append("nameService[]", doc.nameService);
            formData.append("multiFiles", doc.file);
        });

        const response = await api.post("/airbnbDocuments", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return response.data;
    } catch (error) {
        console.error("Error en el registro:", error);
        throw error;
    }
};

export const GET_AIRBNB_BY_PROPERTIE = async (id) => {
	try {
		const response = await api.get(`/airbnbDocuments/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener los edos de cuenta:", error);
		throw error;
	}
};

